// Web: the browser's languages decide, unless the visitor picked one in the
// app or came from a link with ?lang=es (also es-MX, es-ES, de, fr, nl, pl,
// pt-BR, pt-PT, ja, en, auto).

const KEY = "eventlive.language";

function storage() {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch (error) {
    return null;
  }
}

export function readInitialPreference() {
  if (typeof window === "undefined") return null;
  try {
    const fromLink = new URLSearchParams(window.location.search).get("lang");
    if (fromLink) {
      storage()?.setItem(KEY, fromLink);
      return fromLink;
    }
  } catch (error) {}
  try {
    return storage()?.getItem(KEY) || null;
  } catch (error) {
    return null;
  }
}

export async function loadStoredPreference() {
  return readInitialPreference();
}

export async function storePreference(value) {
  try {
    if (value === "auto") storage()?.removeItem(KEY);
    else storage()?.setItem(KEY, value);
  } catch (error) {}
}

export async function reloadApp() {
  if (typeof window === "undefined") return;
  // Drop ?lang= so the link can't undo the choice just made.
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.has("lang")) {
      url.searchParams.delete("lang");
      window.location.replace(url.toString());
      return;
    }
  } catch (error) {}
  window.location.reload();
}
